export function getdata() {
 	var obj = {
 		headlist: [{
 				name: "附加信息项"
 			},
 			{
 				name: "场景模板"
 			}
 		]
 	}
 	return obj
 }
